import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");

@connect(
  (state, props) => {
    var id = CurrentUser.get().id
    return {
      admin: RosterSelectors.admin({ state, id })
    }
  },
  (dispatch, props) => {
    var userID = CurrentUser.get().id
    return {
      populateData: () => {
        return dispatch(RosterActions.fetchAdmins({
          filter: { id: userID },
          embeds: ["admin.related_users"]
        }))
      },
      linkAccounts: function (params) {
        return dispatch(RosterActions.postUserTrigger(userID, params))
      },
      fetchAdmins: () => {
        return dispatch(RosterActions.fetchAdmins({
          filter: { id: userID },
          embeds: ["admin.related_users"]
        }))
      }
    }
  }
)
@providePopulateData({ waitForLoad: true })
class LinkAccountsPreferences extends React.Component {
  constructor(props) {
    super()
    autobind(this)
    this.state = { loading: false }
    LuckyOrangeClient.tagComponent("LinkAccountsPreferences");
  }

  handleLinkAccountSubmit(e) {
    $wr.nope(e)
    LuckyOrangeClient.tagComponent("LinkingAccounts");
    this.setState({ loading: true })
    var username = this.refs.username.value;
    var password = this.refs.password.value;

    var params = { username, password, what: "link_accounts", user_id: this.props.admin.id }

    this.props.linkAccounts(params).then(response => {
      this.setState({ loading: false })
      if (response.success) {
        window.wrNotifications.triggerDropDownNotification({
          title: "Linked!",
          text: "Your accounts have been synced. Your roster has been updated accordingly.",
          icon: "ok-circle",
        });
        this.props.fetchAdmins();
      } else if (response.error) {
        window.wrNotifications.triggerDropDownNotification({
          title: "Accounts not linked!", text: response.error,
          icon: "exclamation-sign", type: "error"
        });
      }
    })
  }

  renderMergeUsersLink() {
    var { admin } = this.props
    var userMergePending = _.filter(admin.related_users, (rUser) => {
      return !rUser.merged_student_lists || !rUser.merged_students
    })

    if (_.size(userMergePending)) {
      return (
        <a className="btn btn-link mergeUsersLink" href={'/settings/merge-users'}>
          Merge users
        </a>
      )
    }
  }

  renderLinkedAccounts() {
    if (this.props.admin && _.size(this.props.admin.related_users)) {
      var related_users = _.map(this.props.admin.related_users, user => {

        if (user.username) {
          var accountDetail = `(username: ${user.username})`
        } else if (user.sign_in_email) {
          var accountDetail = `(email: ${user.sign_in_email})`
        }

        return (
          <span className='relatedUserDisplay' key={'related_user-' + user.id}>
            <strong>{user.first_name} {user.last_name}</strong> {accountDetail}
          </span>
        )
      })
      return (
        <div className='linkedAccountsContainer'>
          <div className='linkedAccountText'>This account is linked with the following accounts:</div>
          {related_users}
          {this.renderMergeUsersLink()}
        </div>
      )
    }
  }

  renderForm() {
    return (
      <div className='accountSyncFormContainer'>
        <div className='accountSyncInstructions'>Have another account? We can link your other account with this one, which will allow you to merge data under any duplicate student accounts under your other account into the matching student accounts in this account.</div>
        <form className="accountSyncForm" onSubmit={this.handleLinkAccountSubmit}>
          <div className="inputRow">
            <label className="inputContainer">
              Username or Email
              <input className="form-control" ref="username"
                placeholder='Username or Email' />
            </label>
            <label className="inputContainer">
              Password
              <input className="form-control" ref="password"
                placeholder='Password' />
            </label>
            <LoadingButton className="btn buttonSuccess center-block" loading={this.state.loading}
              text="Link Account" />
          </div>
        </form>
        <div>Don't have a username or email? <a href='https://whooosreading.zendesk.com/hc/en-us/articles/115001812652-Edit-Your-Name-Username-Email-or-Password' target="_blank">Learn how to create a username</a>.</div>
      </div>
    )
  }

  render() {
    var user = CurrentUser.get();

    return (
      <div className='accountSyncContainer'>
        {this.renderLinkedAccounts()}
        {this.renderForm()}
      </div>      
    );
  }
}

LinkAccountsPreferences.WrappedComponent.propTypes = PageStrictPropTypes({
  //signed in admin
  admin: PropTypes.object,

  populateData: PropTypes.func,
  linkAccounts: PropTypes.func,
  fetchAdmins: PropTypes.func, 
})

module.exports = LinkAccountsPreferences;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/LinkAccountsPreferences.js